import React from 'react';
import { useFormik, FormikProvider } from 'formik';
import Modal from 'app/common/components/Modals/Modal';
import { useDispatch } from 'react-redux';
import { ModalNamesEnum } from 'app/core/enums/ui/modals';
import * as Yup from 'yup';
import FormikForm from 'app/common/components/Form/FormikForm';
import InputTextField from 'app/common/components/Form/Fields/Common/InputTextField';
import InputPasswordField from 'app/common/components/Form/Fields/Common/InputPasswordField';
import { registerNSModalAction } from 'app/store/features/member/register/nsModal/actions';
import { MemberRegisterNSModalProps, PassPhraseLoginFormValues } from './types';

const MemberRegisterNSModal: React.FC<MemberRegisterNSModalProps> = (props) => {
  const reduxDispatch = useDispatch();
  /**
   * @description 密碼驗證 Formik Config
   */
  const memeberRegisterNSFormik = useFormik<PassPhraseLoginFormValues>({
    initialValues: {
      userId: '',
      pswd: ''
    },
    validationSchema: Yup.object().shape({
      userId: Yup.string().required().max(50),
      pswd: Yup.string().required()
    }),
    onSubmit: (formValues) => {
      reduxDispatch(registerNSModalAction({
        ...formValues,
        action: 'R'
      }));
    }
  });

  /**
   * @description 處理關閉 Modal
   */
  const handleCloseModal = () => {
    memeberRegisterNSFormik.resetForm();
  };

  return (
    <Modal
      name={ModalNamesEnum.MemberRegisterNSModal}
      className="member-login-modal"
      title="網服會員身份驗證"
      visible={props.visible}
      onClose={handleCloseModal}
    >
      <FormikProvider value={memeberRegisterNSFormik}>
        <FormikForm>
          <div className="login-inputs-container m-0">
            {/* 帳號 */}
            <InputTextField
              name="userId"
              label="帳號"
              wrapClassName="item"
              placeholder="請輸入帳號"
              aria-label="帳號"
            />
            {/* 密碼 */}
            <InputPasswordField
              name="pswd"
              label="密碼"
              wrapClassName="item"
              placeholder="請輸入密碼"
              disabledShowPassWord
            />
            <button type="submit" className="btn btn-primary send-verify-code">驗證</button>
          </div>
        </FormikForm>
      </FormikProvider>
    </Modal>
  );
};

export default MemberRegisterNSModal;
